import axios from 'axios';

const URLASSOLUTOAPI = process.env.MIX_URLASSOLUTO_IT; // deve essere sempre l'italiano

export default axios.create({
	baseURL: URLASSOLUTOAPI,
});
